module.exports = __webpack_public_path__ + "static/media/about-banner.a398789f.png";